import React, { useState } from "react";
import {
  IoChevronDownOutline,
  IoChevronUpOutline,
  IoTrashOutline,
  IoCloseOutline,
} from "react-icons/io5";
import "../../Dashboard/pages/pages.css"; // reuse existing styles

const RecordedLessons = () => {
  const [courses, setCourses] = useState([
    {
      id: 1,
      title: "React Course",
      description: "Learn React from basics to advanced",
      deadline: "2026-04-10",
      recordedLessons: [
        {
          id: 1,
          title: "React Intro Video",
          videoUrl: "https://www.w3schools.com/html/mov_bbb.mp4",
        },
        {
          id: 2,
          title: "Hooks Recorded Session",
          videoUrl: "https://www.w3schools.com/html/movie.mp4",
        },
      ],
    },
    {
      id: 2,
      title: "Node Course",
      description: "Backend development with Node.js",
      deadline: "2026-05-01",
      recordedLessons: [],
    },
  ]);

  const [expandedCourse, setExpandedCourse] = useState(null);

  // Modal for video
  const [videoModal, setVideoModal] = useState(false);
  const [currentVideo, setCurrentVideo] = useState("");

  const [expandedLesson, setExpandedLesson] = useState(null);

  // Delete recorded lesson
  const deleteRecordedLesson = (courseId, lessonId) => {
    const updated = courses.map((course) =>
      course.id === courseId
        ? {
            ...course,
            recordedLessons: course.recordedLessons.filter(
              (l) => l.id !== lessonId,
            ),
          }
        : course,
    );
    setCourses(updated);
  };

  // Delete course
  const deleteCourse = (courseId) => {
    setCourses(courses.filter((c) => c.id !== courseId));
  };

  // Open video modal
  const openVideoModal = (videoUrl) => {
    setCurrentVideo(videoUrl);
    setVideoModal(true);
  };

  return (
    <div className="overview-container">
      <h2>Recorded Lessons</h2>

      <table className="lessons-table">
        <thead>
          <tr>
            <th>Course Title</th>
            <th>Description</th>
            <th>Deadline</th>
            <th>Recorded Lessons</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {courses.map((course) => (
            <React.Fragment key={course.id}>
              <tr>
                <td>{course.title}</td>
                <td>{course.description}</td>
                <td>{course.deadline}</td>

                {/* Lessons Dropdown */}
                <td>
                  {course.recordedLessons.length > 0 ? (
                    <button
                      className="lesson-btn"
                      onClick={() =>
                        setExpandedCourse(
                          expandedCourse === course.id ? null : course.id,
                        )
                      }
                    >
                      {expandedCourse === course.id ? (
                        <IoChevronUpOutline />
                      ) : (
                        <IoChevronDownOutline />
                      )}
                    </button>
                  ) : (
                    <span className="no-lessons">No Recorded Lessons</span>
                  )}
                </td>

                {/* Course Actions */}
                <td>
                  <button
                    className="delete-btn"
                    onClick={() => deleteCourse(course.id)}
                  >
                    <IoTrashOutline />
                  </button>
                </td>
              </tr>

              {/* Expanded Lessons Table */}
              {expandedCourse === course.id &&
                course.recordedLessons.length > 0 && (
                  <tr>
                    <td colSpan="5">
                      <table className="inner-table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Lesson Title</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {course.recordedLessons.map((lesson, index) => (
                            <tr key={lesson.id}>
                              <td>{index + 1}</td>

                              {/* Click lesson title to open video modal */}
                              <td
                                style={{
                                  cursor: "pointer",
                                  color: "#4f46e5",
                                  fontWeight: 500,
                                }}
                                onClick={() => openVideoModal(lesson.videoUrl)}
                              >
                                {lesson.title}
                              </td>

                              <td>
                                <button
                                  className="delete-btn"
                                  onClick={() =>
                                    deleteRecordedLesson(course.id, lesson.id)
                                  }
                                >
                                  <IoTrashOutline />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                )}
            </React.Fragment>
          ))}
        </tbody>
      </table>

      {/* Video Modal */}
      {videoModal && (
        <div
          className="video-modal-overlay"
          onClick={() => setVideoModal(false)}
        >
          <div
            className="video-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="video-modal-header">
              <IoCloseOutline
                size={28}
                style={{ cursor: "pointer" }}
                onClick={() => setVideoModal(false)}
              />
            </div>
            <video width="100%" height="auto" controls autoPlay>
              <source src={currentVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecordedLessons;
